import firedux from '../firedux'
import {getState} from '../store'

import {
  CONVERSATION_STACKS_ENDPOINT
} from '../../config/constants'

export default (currentUserUid, viewportType) => {
  let stack = getState().getIn(['conversations', '_stack', 'list'])

  if (stack) return Promise.resolve(stack)

  const ref = firedux.ref.child(CONVERSATION_STACKS_ENDPOINT).child(viewportType).child(currentUserUid)

  return ref.once('value')
    .then((snapshot) => snapshot.val())
    // TODO: add dispatcher for setting conversation stack.
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/conversation_stack.js
 **/